$(document).ready(function(){
  // Add smooth scrolling to all links
  $("a").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){

        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
    } // End if
  });

  // Buy it now button

  $('.menu-buy-now').parent().parent().on('click', function(e){

    e.preventDefault();

    console.log('buy it now');

    $('.slideshow:first-child').find('.btn').click();
  });

  // check URL parameter on product page and jump to Buy now section

  var urlParams = new URLSearchParams(window.location.search); //get all parameters
  var foo = urlParams.get('variant'); //extract the foo parameter - this will return NULL if foo isn't a parameter

  if(foo) { //check if foo parameter is set to anything
      if(foo > 0){
        $('.slideshow:first-child').find('.btn').click();
      }
  }

  // swiper
  //swiper-slide-next
  $('.swiper-arrow-added-right').click(function(e){
    e.preventDefault();
    $('.swiper-pagination-bullet-active').next().click();
  });
  $('.swiper-arrow-added-left').click(function(e){
    e.preventDefault();
    $('.swiper-pagination-bullet-active').prev().click();
  });


});
